<template>
  <div v-loading="isLoading">
    <el-alert class="mb-3" :title="err" type="error" show-icon v-if="err"></el-alert>
    <el-upload class="upload-demo" drag auto-upload :before-upload="verifyUpload" :show-file-list="false" action=""
      :http-request="uploadFile" accept="text/csv">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
      <div class="el-upload__tip" slot="tip">Import Client data from the Tax Software</div>
    </el-upload>
  </div>
</template>

<script>
import get from 'lodash/get';
import api from '@/api';

export default {
  data() {
    return {
      err: null,
      isLoading: false,
    };
  },
  methods: {
    verifyUpload(file) {
      this.isLoading = true;
      this.err = null;
      if (!file) {
        this.err = 'An error occurred. Please try again.';
      }

      if (file.type !== 'text/csv' && !file.name.toLowerCase().endsWith('csv')) {
        this.err = 'Invalid File Type. Only CSV files exported from the Tax Software are supported.';
      }

      if (this.err) {
        this.isLoading = false;
        return false;
      }
      return true;
    },
    uploadFile(data) {
      api.client.import(data.file).then((response) => {
        this.$emit('success', response.data);
      }).catch((e) => {
        this.err = get(e, 'response.data', 'An error occurred.');
      }).finally(() => {
        this.isLoading = false;
      });
    },
  },
};

</script>
